export default __webpack_public_path__ + "static/media/netflix.f8404f28.png";